//React
import React from "react";

import axios from 'axios';
import config from '../config';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as uiAction from '../action/uiAction';
import * as mailGroupAction from '../action/mailGroupAction';
import * as mailSupportAction from '../action/mailSupportAction';
//Material-ui
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

//Add
import Cookies from 'js-cookie';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import ReactPaginate from 'react-paginate';
//func
import atom2datetime from '../func/atom2datetime';
//Part
import PartUserMainImg from './PartUserMainImg';
import PartUserName from './PartUserName';
import PartUrl2Button from './PartUrl2Button';
//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ClearIcon from '@material-ui/icons/Clear';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';

class Comp extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();

    let imgMaxWidth;
    if ((window.innerWidth * 0.7) > 300) {
      imgMaxWidth = 300;
    }
    else {
      imgMaxWidth = (window.innerWidth * 0.7);
    }

  	this.state = {
      pic: this.props.match.params.pic,
      partnerName: null,
      partnerImg: null,
      partnerSex: null,

      mailListPage: 1,
      mailList: [],
      mailListTotalCount: 0,
      mailListOutputCount: 1,
      mailListBlockHeight: 600,

      mailDelId: null,
      mailDelAnchor: null,


      textareaText: '',
      textareaFocus: false,
      textareaMinHeight: 50,
      textareaMaxHeight: 50,
      textMailDialogVisible: false,


      imgMaxWidth: imgMaxWidth,
  	}

    window.addEventListener('resize', this._adjustBlockHeight);
  }



  componentDidMount() {
    document.title = 'サポートからのメール - パートナーズ';
    this._mailSupportListGet(1, true);
    var list = document.querySelector('#mail_list_block');
    disableBodyScroll(list);
  }


  componentDidUpdate(prevProps, prevState) {
    if (this.state.textareaMaxHeight !== prevState.textareaMaxHeight) {
      this._adjustBlockHeight();
    }
    if (this.state.mailListBlockHeight !== prevState.mailListBlockHeight) {
      let diff = prevState.mailListBlockHeight - this.state.mailListBlockHeight;
      if (diff > 0) {
        let scroll = this.myRef.current.scrollTop + diff;
        document.getElementById('mail_list_block').scrollTo(0, scroll);
      }

    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._adjustBlockHeight);
    clearAllBodyScrollLocks();
  }

  _mailSupportListGet(page, scrollBottom) {
    this.props.mailSupportListGet(page, (data) => {
      this.setState({
        mailList: data.list,
        mailListTotalCount: data.totalCount,
        mailListOutputCount: data.outputCount,
        mailListDatetime: (new Date()),
      });

      this._adjustBlockHeight();
      if (scrollBottom) {
        this._scrollBottom();
      }
      this.props.mailGroupItemConfirmed('support');
    });
  }

  _renderList = (item, index) => {
    let contents;

    contents = (
      <div style={{whiteSpace: 'pre-line'}}>
        <PartUrl2Button text={item.mail_text} />
      </div>
    );


    if (item.mail_trans_recept === 'trans') {
  		return (
        <div key={index} align='right' style={{margin:'10px'}}>

          <div className='talk_balloon_right round12' style={{marginRight:'10px'}}>
            <div style={{fontSize:'0.9em',color:'#666'}}>
              {atom2datetime(item.mail_transmission_atom, 'DT')}
            </div>

            {contents}

            <IconButton
              style={{position:'absolute', right:'-15px', bottom:'-15px'}}
              onClick={ () => this.setState({ mailDelId: item.mail_id}) }
            >
              <ClearIcon />
            </IconButton>
          </div>

        </div>
      );
    }
    else if (item.mail_trans_recept === 'recept') {
  		return (
        <div key={index} align='left' style={{margin:'10px'}}>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'top',
              justifyContent:'start',
            }}
          >
            <PartUserMainImg
              mainImg={{
                src: null,
                sex: this.props.my.profile.userdata_opposite_sex,
              }}
              width={'30px'}
              height={'30px'}
              radius={'50%'}

            />

            <div className='talk_balloon_left round12' style={{marginLeft:'10px'}}>
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent:'space-between',
                }}
              >
                <div style={{fontSize:'0.9em',color:'#666'}}>
                  {atom2datetime(item.mail_transmission_atom, 'DT')}
                </div>
                &nbsp;
                <IconButton
                  size='small'
                  onClick={ (event) => this.setState({mailEditId:item.mail_id, mailEditAnchor:event.currentTarget}) }
                >
                  <MoreVertSharpIcon
                    style={{fontSize:'1.2em',color:'#999'}}
                  />
                </IconButton>

              </div>
              <div style={{whiteSpace: 'pre-line'}}>
                {contents}
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  _adjustBlockHeight　= () => {
    let height = document.documentElement.clientHeight - (document.getElementById('mail_menu_block').clientHeight + document.getElementById('mail_form_block').clientHeight)
    console.log('adjust');
    this.setState({ mailListBlockHeight: height});
  }


  _scrollBottom = () => {
    //var element = document.getElementById('mail_list_block');
    //element.scrollIntoView(false);
  	document.getElementById('mail_list_block').scrollTo(0, (this.myRef.current.scrollHeight -1));
    console.log(this.myRef.current.scrollHeight);
  }

  _mailDelSubmit(mailId) {
    let params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('mailId', mailId);
    axios.post(config.apiUri + "member/mailTalkEditApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      if (res.data.bool) {
        let list = this.state.mailList;
        let index = list.findIndex((v) => v.mail_id === mailId);
        if (index >= 0) {
    		  list.splice( index, 1 );
        }
        this.setState({mailList: list});
      }
    })
    .catch((err) => {
      this.props.snackOpen('error', 'インターネットに接続できませんでした', 5000);
    })
  }

  _historyBack() {
    if (this.props.location.referrer) {
      this.props.history.goBack();
    }
    else{
      this.props.history.push('/mailbox/');
    }
  }


  render() {
    return (
      <Box id='mail_block' style={{maxWidth:'600px', margin:'auto'}} className='box_inner' boxShadow={2}>
        <div style={{width:'100%', display:'flex', flexDirection:'column'}} border='0'>

          <div
            id ='mail_menu_block'
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent:'space-between',
              background:'#F5F5F5',
            }}
            className='shadow'
          >
            <div>
              <div style={{display:'flex',flexDirection:'row',justifyContent:'center', alignItems:'center'}}>

                <IconButton onClick={ () => this._historyBack() }>
                  <ArrowBackIosIcon />
                </IconButton>
                {
                  (this.state.partnerMainImg) && (
                    <span
                      style={{cursor:'pointer'}}
                      onClick={ () => this.props.history.push('/partner/' + this.state.pic) }
                    >
                      <PartUserMainImg
                        mainImg={{
                          src: null,
                          sex: this.props.my.profile.userdata_opposite_sex,
                        }}
                        width={'40px'}
                        height={'40px'}
                        radius={'50%'}
                        background={'#FFF'}
                      />
                    </span>
                  )
                }
                &nbsp;
                <span
                  style={{cursor:'pointer'}}
                  onClick={ () => this.props.history.push('/contact/') }
                >
                  <PartUserName
                    data={{
                      name: 'カスタマーサポート',
                      sex: this.props.my.profile.userdata_opposite_sex,
                      size: '1.2em',
                    }}
                  />
                </span>
              </div>
            </div>

            <div>
              <IconButton
                onClick={ () => this._mailSupportListGet(1, true) }
              >
                <RefreshIcon/>
              </IconButton>

            </div>
          </div>

            <div style={{background:'#bdcee0', position:'relative'}}>
              <div
                id='mail_list_block'
                style={{
                  overflowY:'scroll',
                  WebkitOverflowScrolling: 'touch',
                  height:this.state.mailListBlockHeight+'px',
                  background:'#bdcee0',
                  position:'relative',
                }}
                ref={this.myRef}
              >
                {
                  (Math.ceil(this.state.mailListTotalCount / this.state.mailListOutputCount) > 1) && (
                    <div style={{textAlign:'center',margin:'10px'}}>
                      <ReactPaginate
                        breakLabel="…"
                        previousLabel="<"
                        nextLabel=">"
                        onPageChange={ (event) => this._mailSupportListGet((event.selected + 1), true) }
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={1}
                        pageCount={ Math.ceil(this.state.mailListTotalCount / this.state.mailListOutputCount) }
                        renderOnZeroPageCount={null}
                        containerClassName={'pagingBlock'}
                        pageLinkClassName={'item'}
                        previousLinkClassName={'item'}
                        nextLinkClassName={'item'}
                        activeLinkClassName={'select'}
                        disabledClassName={'itemDisabled'}
                      />
                    </div>
                  )
                }


                {
                  this.state.mailList.map(
                    (item, index) => this._renderList(item, index)
                  )
                }

                <Menu
                  anchorEl={this.state.mailEditAnchor}
                  keepMounted
                  open={(this.state.mailEditId)? true: false}
                  onClick={ () => this.setState({mailEditId: null}) }
                >
                  <MenuItem
                    onClick={ () => {
                      this._mailDelSubmit(this.state.mailEditId);
                      this.setState({mailEditId: null});
                    }}
                  >
                    <div>
                      メールを削除する
                    </div>

                  </MenuItem>
                </Menu>

              </div>
              <div
                style={{
                  display: (this.state.textareaFocus) ? 'block' : 'none',
                  position:'absolute',
                  top: '0px',
                  left: '0px',
                  height: '100%',
                  width: '100%',
                }}
                onClick={ () => this._textareaBlur() }
              />
            </div>


            <div id='mail_form_block'  style={{background:'#F5F5F5'}}>
            </div>
        </div>
      </Box>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    my: state.my,
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    ...uiAction,
    ...mailGroupAction,
    ...mailSupportAction,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
